import React from 'react';
import SvgTear from './SvgTear';
import SvgBook from './SvgBook';

const SecondScreen = () => {
  return (
    <div
      className="px-5 my-10 tablet:my-25 tablet:px-22.5"
      data-ele-id="content"
      data-ele-group="2nd_screen"
      data-observer-id="2nd_screen"
    >
      <div className="tablet:max-w-[1200px] tablet:mx-auto">
        <p className="text-3xl font-semibold text-center tablet:text-4.5xl">
          发现简历短板，获取专属优化建议
        </p>
        <p className="text-lg mt-4 mb-10 text-center tablet:text-xl">
          通过深入诊断，精准定位改进方向，让您的简历更具竞争力
        </p>
        <div className="flex flex-col gap-10 justify-between tablet:flex-row tablet:whitespace-nowrap">
          <div className="flex-1 group p-4 bg-web-warning-100 rounded-lg m-0.5 transition-colors duration-75 shrink-0 hover:border-2 hover:border-web-warning-600 hover:m-0 tablet:px-10 tablet:py-7.5">
            <SvgTear className="transition-all duration-100 group-hover:scale-105" />
            <p className="mt-6 text-lg font-semibold tablet:text-xl">
              你可能不知道的真相：
            </p>
            <ul className="text-sm list-inside !ml-2 tablet:text-base">
              <li className="mt-4">
                {`80 % 的求职者因简历"隐形扣分项"被淘汰，却始终找不到症结所在。`}
              </li>
              <li className="mt-4">
                HR平均6秒决定一份简历的去留，你的简历能抓住黄金6秒吗？
              </li>
              <li className="mt-4">
                90%的职场人重复使用同一份简历，却不知岗位匹配度决定成败。
              </li>
            </ul>
          </div>
          <div className="flex-1 group p-4 bg-web-aqua-100 rounded-lg m-0.5 transition-colors duration-75 hover:border-2 hover:border-web-aqua-600 hover:m-0 tablet:px-10 tablet:py-7.5">
            <SvgBook className="transition-all duration-100 group-hover:scale-105" />
            <p className="mt-6 text-lg font-semibold tablet:text-xl">
              当你的简历出现这些信号，请立即诊断：
            </p>
            <ul className="text-sm !list-none !ml-0 tablet:text-base">
              <li className="mt-4">✓ 面试邀约率持续走低</li>
              <li className="mt-3">✓ 转行/转岗时遭遇适配性质疑</li>
              <li className="mt-3">✓ 无法突出自己的不可替代性</li>
              <li className="mt-3">✓ 工作5年仍用应届版式</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondScreen;
